import React from "react";

export default function Dashboard() {
    return (
        <div className="container mt-4">
            <h2>Dashboard</h2>
            <p className="text-muted">Overview coming soon...</p>
        </div>
    );
}
